import React, { Fragment, useState } from 'react';
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import { H4 } from '../../../AbstractElements';
import CreatePOForm from './CreatePOForm';
import POListTable from './POListTable';
import ConsumptionLogTable from './ConsumptionLogTable';
import '../../Admin/Licenses/licenses.scss';

const LicensesBackendUserPage = () => {
    const [tab, setTab] = useState('create');
    const [poRefreshKey, setPoRefreshKey] = useState(0);

    return (
        <Fragment>
            <Breadcrumbs parent='Backend' title='License Administration' />
            <div className='license-glass-page'>
                <Container fluid>
                    <H4 className='mb-1'>License Administration</H4>
                    <div className='license-card-sub mb-3'>
                        Create POs, review the full pool, and audit every consumption.
                    </div>

                    <Nav tabs className='mb-3'>
                        <NavItem>
                            <NavLink
                                active={tab === 'create'}
                                onClick={() => setTab('create')}
                                style={{ cursor: 'pointer' }}>
                                Create PO
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                active={tab === 'pos'}
                                onClick={() => setTab('pos')}
                                style={{ cursor: 'pointer' }}>
                                All POs
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                active={tab === 'logs'}
                                onClick={() => setTab('logs')}
                                style={{ cursor: 'pointer' }}>
                                Consumption Log
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={tab}>
                        <TabPane tabId='create'>
                            <CreatePOForm onCreated={() => setPoRefreshKey(k => k + 1)} />
                        </TabPane>
                        <TabPane tabId='pos'>
                            <POListTable refreshKey={poRefreshKey} />
                        </TabPane>
                        <TabPane tabId='logs'>
                            <ConsumptionLogTable />
                        </TabPane>
                    </TabContent>
                </Container>
            </div>
        </Fragment>
    );
};

export default LicensesBackendUserPage;
